/** Altura por hora por defecto en la agenda desktop v2 (px). */
export const HOUR_HEIGHT_DEFAULT_PX = 52;

/** Horas que se intentan mostrar sin scroll en la agenda desktop (00:00-13:00). */
export const HORAS_VISIBLES_DEFAULT = 13;

export const HOUR_HEIGHT_MIN_PX = 36;
export const HOUR_HEIGHT_MAX_PX = 80;

/**
 * Altura por hora (múltiplo de 4 para slots enteros) para que quepan
 * `horas` en `espacioPx`, acotada entre mínimo y máximo legibles.
 */
export function alturaHoraAjustada(espacioPx: number, horas: number): number {
  if (!(espacioPx > 0) || !(horas > 0)) return HOUR_HEIGHT_DEFAULT_PX;
  const ajustada = Math.floor(espacioPx / horas / 4) * 4;
  return Math.min(HOUR_HEIGHT_MAX_PX, Math.max(HOUR_HEIGHT_MIN_PX, ajustada));
}

/** Altura mínima (px) de una tarjeta v2: cabe una línea de 11-12 px. */
export const ALTURA_MINIMA_CITA_PX = 14;

/** Hora a la que se posiciona la grilla si la semana no tiene citas. */
export const HORA_INICIAL_SIN_CITAS = 7;

/** Citas de menos de estos minutos se muestran en una sola línea. */
export const MINUTOS_CITA_CORTA = 30;

/** Altura de un slot de 15 min para una altura por hora dada. */
export function alturaSlotPx(alturaHoraPx: number): number {
  return alturaHoraPx / 4;
}

/** Altura de una cita (px) descontando 2 px de borde, igual que la grilla actual. */
export function alturaCitaPx(
  nmhorasCita: number | null | undefined,
  alturaHoraPx: number
): number {
  const horas = nmhorasCita ?? 1;
  return horas * alturaHoraPx - 2;
}

export function esCitaCorta(nmhorasCita: number | null | undefined): boolean {
  return Math.round((nmhorasCita ?? 1) * 60) < MINUTOS_CITA_CORTA;
}

/** Offset (px) desde el inicio de la grilla para una hora decimal. */
export function offsetHoraPx(hora: number, alturaHoraPx: number): number {
  return hora * alturaHoraPx;
}

/**
 * Hora (entera) de la primera cita de las fechas indicadas, o
 * HORA_INICIAL_SIN_CITAS si no hay ninguna.
 */
export function primeraHoraConCitas(
  citas: readonly { feprogramacion?: string | null }[],
  fechas: readonly string[]
): number {
  let minimo: number | null = null;
  for (const cita of citas) {
    if (!cita.feprogramacion) continue;
    const d = new Date(cita.feprogramacion);
    const fecha = fechaLocal(d);
    if (!fechas.includes(fecha)) continue;
    const hora = d.getHours();
    if (minimo === null || hora < minimo) minimo = hora;
  }
  return minimo ?? HORA_INICIAL_SIN_CITAS;
}

/** Posición (px) de la línea de hora actual dentro de su slot de 15 min. */
export function offsetIndicadorEnSlotPx(
  minutos: number,
  alturaHoraPx: number
): number {
  return ((minutos % 15) / 15) * alturaSlotPx(alturaHoraPx);
}

/** Reparto horizontal de N citas que inician en el mismo slot. */
export function repartoHorizontal(
  indice: number,
  total: number
): { left: number; width: number } {
  const n = Math.max(1, total);
  return { left: (indice * 100) / n, width: 100 / n };
}

export function fechaLocal(d: Date): string {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
